import React, { useContext, useEffect, useState } from "react";
import { Colorcontext } from "../../Component/Colorcontext/ColorContext";
// import vectorarrow from "../../Images/vectorarrow.png";
import { Link, useLocation, useNavigate } from "react-router-dom";
import HttpClient from "../../utils/HttpClient";
// import Workprogressbar from "../SearchHome/Workprogressbar";
// import Selectplancomp from "../SearchHome/Selectplancomp";
import "./Style.css"

const CardMemberRegistrationDetails = () => {
  const colordata = useContext(Colorcontext);
  const location = useLocation();
  const navigate = useNavigate();
  const { username, password, profileTypeID, userName, personName, designationID, phone_code, telephoneNo, mobileNo, emirate, companyName, companyTypeID, websiteLink, emailId } = location.state || {};

  // const [toggleDesignation, setToggleDesignation] = useState(false);
  // const [toggleTypeOfBussiness, setToggleTypeOfBussiness] = useState(false);
  // const [toggleState, setToggleState] = useState(false);
  // const [toggleCountry, setToggleCountry] = useState(false);
  // const [designationName, setDesignationName] = useState("");
  // const [bussinessName, setBussinessName] = useState("");
  // const [drowdowsncustom, setDrowdowsncustom] = useState(false);
  // const [selectedPlan, setSelectedPlan] = useState({ _id: "", name: "" });
  // const [plans, setPlans] = useState([]);

  const [country, setCountry] = useState([]);
  const [designation, setDesignation] = useState([]);
  const [company, setCompany] = useState([]);
  const [countryState, setCountryState] = useState([]);
  const [formData, setFormData] = useState({
    profileTypeID: profileTypeID || "",
    userName: userName || "",
    password: password,
    personName: personName || "",
    designationID: designationID || "",
    phone_code: phone_code || "+971",
    countryCodePhone: phone_code || "+971",
    telephoneNo: telephoneNo || "",
    countryCodeMobile: phone_code || "+971",
    mobileNo: mobileNo || "",
    emirate: emirate || "",
    country: "65f95f070d6753c3bdacccd9",
    companyName: companyName || "",
    companyTypeID: companyTypeID || "",
    websiteLink: websiteLink || "",
    emailId: username,
  });
  const [errors, setErrors] = useState({});

  useEffect(() => {
    // !username && navigate("/business-directory-listing-pricing")
    colordata.setcolor(true);
    return () => {
      colordata.setcolor(false);
    };
  }, []);

  // const _getState = async () => {
  //   const res = await HttpClient.requestData(
  //     "countrywise-state/" + "65f95f070d6753c3bdacccd9",
  //     "GET",
  //     {}
  //   );
  //   if (res && res?.status) {
  //     setCountryState(res?.data?.[0]?.states);
  //   }
  // };

  useEffect(() => {
    getProfileType()
    getCountry();
    getState();
    getCompanyType();
    getDesignation();

  }, []);

  const getCompanyType = async () => {
    const response = await HttpClient.requestData("companyType", "GET", "");
    if (response.status) {
      setCompany(response.data);
    } else {
      console.log("Error while fetching company data");
    }
  };

  // const _getCountry = async () => {
  //   const response = await HttpClient.requestData("countries-list", "GET", "");
  //   if (response.status) {
  //     setCountry(response.data);
  //   } else {
  //     console.log("Error while fetching country data");
  //   }
  // };

  //country
  const getCountry = async () => {
    const res = await HttpClient.requestData("countries", "GET", {});

    if (res && res?.status) {
      setCountry(res?.data);
      // setNonMemberProfileAdd({
      //   ...NonMemberProfileAdd,
      //   countryCodeMobile: res.data[0].phone_code,
      //   countryCodewhatsappNo: res.data[0].phone_code,
      // });
    }
  };

  const getDesignation = async () => {
    const response = await HttpClient.requestData("designation", "GET", "");
    if (response.status) {

      setDesignation(response.data);
    } else {
      console.log("Error while fetching designation data");
    }
  };

  const [profileTypes, setProfileTypes] = useState([])
  const getProfileType = async () => {
    const response = await HttpClient.requestData("profile-type", "GET", "");
    if (response.status) {

      setProfileTypes(response.data);
    } else {
      console.log("Error while fetching designation data");
    }
  };

  // const getPlan = async () => {
  //   const res = await HttpClient.requestData("subscription-plans", "GET", "");
  //   if (res && res.status) {
  //     setPlans(res?.data.reverse());
  //   } else {
  //     console.log("Error from getting subscription:", res);
  //   }
  // };

  // const choosedPlan = () => {
  //   if (plans.length === 0 || !choosePlanID) return;
  //   const selected = plans.find((item) => item._id === choosePlanID);
  //   if (selected) {
  //     setSelectedPlan({ _id: selected._id, name: selected.plan });
  //   }
  // };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    // name === "mobileNo" && (value = countryCodeMobile + value)
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
    validateField(name, value);
  };

  const validateField = (fieldName, value) => {
    let error = "";
    switch (fieldName) {
      // case "personName":
      //   if (!value) error = "Name is required";
      //   break;
      // case "companyName":
      //   if (!value) error = "Company Name is required";
      //   break;

      // case "telephoneNo":
      //   if (!value) error = "Copany number is required";
      //   else if (!/^\d{10}$/.test(value))
      //     error = "Company number must be 10 digits";
      //   break;

      case "mobileNo":
        if (!value) error = "Mobile number is required";
        else if (!/^\d{10}$/.test(value))
          error = "Mobile number must be 10 digits";
        break;

      // case "emailId":
      //   if (!value) error = "Email is required";
      //   else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value))
      //     error = "Invalid email format";
      //   break;

      // case "address":
      //   if (!value) error = "Address is required";
      //   break;

      case "emirate":
        if (!value) error = "Emirate is required";
        break;

      default:
        break;
    }
    setErrors((prevErrors) => ({ ...prevErrors, [fieldName]: error }));
  };

  const requiredFields = [
    { fieldID: "personName", fieldName: "Full name" },
    { fieldID: "profileTypeID", fieldName: "Profile Type" },
    { fieldID: "designationID", fieldName: "Designation" },
    { fieldID: "companyTypeID", fieldName: "Type of business" },
    { fieldID: "companyName", fieldName: "Company name is required" },
    { fieldID: "mobileNo", fieldName: "Mobile number" },
    { fieldID: "emailId", fieldName: "Work email" },
    { fieldID: "emirate", fieldName: "State" },
    { fieldID: "country", fieldName: "Country" },
  ];

  const validateForm = () => {
    const newErrors = {};
    let isValid = true;

    // Check required fields
    requiredFields.forEach((field) => {
      // Skip companyName and companyTypeID if profileTypeID is personal
      if (formData.profileTypeID === "65df70ab31670c8a6a8c5d76" &&
        (field.fieldID === "companyName" || field.fieldID === "companyTypeID")) {
        return;
      }

      if (!formData[field.fieldID]) {
        newErrors[field.fieldID] = `${field.fieldName} is required`;
        isValid = false;
      }
    });

    // Validate mobile number (10 digits)
    // if (!/^\d{10}$/.test(formData.mobileNo)) {
    //   newErrors.mobileNo = "Mobile number must be 10 digits";
    //   isValid = false;
    // }


    // Validate optional telephone number (10 digits)
    // if (formData.telephoneNo && !/^\d{10}$/.test(formData.telephoneNo)) {
    //   newErrors.telephoneNo = "Telephone number must be 10 digits";
    //   isValid = false;
    // }

    // Validate email format
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.emailId)) {
      newErrors.emailId = "Invalid email format";
      isValid = false;
    }

    setErrors(newErrors);
    return isValid;
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    const updatedFormData = {
      ...formData,
      phone_code: formData.countryCodeMobile,

      //mobileNo: (formData.countryCodeMobile || '+971') + ' ' + formData.mobileNo,
      //telephoneNo: (formData.countryCodePhone || '+971') + ' ' + formData.telephoneNo,
    };
    let cleanedData;
    if (updatedFormData.profileTypeID === "65df70ab31670c8a6a8c5d76") {
      const { companyName, companyTypeID, countryCodeMobile, countryCodePhone, ...rest } = updatedFormData;
      cleanedData = rest;
    } else {
      const { countryCodeMobile, countryCodePhone, ...rest } = updatedFormData;
      cleanedData = rest;
    }


    // Remove countryCodeMobile
    // delete updatedFormData.countryCodeMobile;
    // delete updatedFormData.countryCodePhone;


    // return
    if (validateForm()) {
      navigate("/create-businesscard-profile", {
        state: { formData: cleanedData },
      })
    } else {
      console.log("Error");
    }
  };

  //state
  const getState = async () => {
    const res = await HttpClient.requestData(
      "countrywise-state/" + formData.country,
      "GET",
      {}
    );

    if (res && res?.status) {
      setCountryState(res?.data?.[0]?.states);
    }
  };

  useEffect(() => {
    getState();
  }, [formData.country]);

  return (
    <>
      <section className="listbusinessformdivmain">
        <div className="cust_container">
          <div className="_listbusinessdivflx">
            <div className="_listbusinessdivleft">

              <div className="listbusinessdivleftbg">
                <p className="conattaindptxtpp">Contact information</p>

                <div className="contatcindofdicfplx">

                  <div className="contatcindofdiinpur" style={{ maxWidth: "100%" }}>
                    <p className="contatcindofdiinpurtxtp">
                      Profile type <span> *</span>
                    </p>
                    <select className="neooSelect"
                      name="profileTypeID"
                      value={formData.profileTypeID}
                      onChange={handleInputChange}
                    >
                      <option value="">Choose...</option>
                      {
                        profileTypes?.map((item) => {
                          return (
                            <><option value={item._id} key={item._id}>{item.name}</option></>
                          )
                        })
                      }
                    </select>
                    {errors.profileTypeID && (
                      <span className="error">{errors.profileTypeID}</span>
                    )}
                  </div>


                  <div className="contatcindofdiinpur">
                    <p className="contatcindofdiinpurtxtp">
                      Full name <span>*</span>
                    </p>
                    <input
                      type="text"
                      name="personName"
                      value={formData.personName}
                      onChange={handleInputChange}
                      placeholder="John Doe"
                      className="neooTextbox"
                    />
                    {errors.personName && (
                      <span className="error">{errors.personName}</span>
                    )}
                  </div>

                  <div className="contatcindofdiinpur">
                    <p className="contatcindofdiinpurtxtp">
                      Designation <span> *</span>
                    </p>

                    <select className="neooSelect"
                      name="designationID"
                      value={formData.designationID}
                      onChange={handleInputChange}
                    >
                      <option value="">Choose...</option>
                      {
                        designation?.map((item) => {
                          return (
                            <><option value={item._id}>{item.designation}</option></>
                          )
                        })
                      }
                    </select>

                    {errors.designationID && (
                      <span className="error">{errors.designationID}</span>
                    )}
                  </div>
                  <div className="contatcindofdiinpur">
                    <p className="contatcindofdiinpurtxtp">Tel number</p>
                    <div className="input-wrapper">
                      <select
                        className="_form-control _countrycodebox inpustxocntbusuitxtpp"
                        aria-label="Default select example"
                        name="countryCodePhone"
                        style={{
                          width: "30%",
                          background: "#fff",
                        }}
                        value={formData.countryCodePhone}
                        onChange={handleInputChange}
                      >
                        {country.map((item, i) => (
                          <option key={i} value={item?.phone_code}>
                            {item?.emoji} {item?.phone_code}
                          </option>
                        ))}
                      </select>
                      <input
                        // type="number"
                        name="telephoneNo"
                        value={formData.telephoneNo}
                        onChange={handleInputChange}
                        placeholder="Tel number"
                        className="inpustxocntbusuitxtpp"
                        style={{
                          width: "70%"
                        }}
                      />
                    </div>
                    {errors.telephoneNo && (
                      <span className="error">{errors.telephoneNo}</span>
                    )}
                  </div>
                  <div className="contatcindofdiinpur">
                    <p className="contatcindofdiinpurtxtp">
                      Mobile number<span> *</span>
                    </p>
                    <div className="input-wrapper">
                      <select
                        className="_form-control _countrycodebox inpustxocntbusuitxtpp"
                        aria-label="Default select example"
                        name="countryCodeMobile"
                        style={{
                          width: "30%",
                          background: "#fff",
                        }}
                        value={formData.countryCodeMobile || "+971"}
                        onChange={handleInputChange}
                      >
                        {country.map((item, i) => (
                          <option key={i} value={item?.phone_code}>
                            {item?.emoji} {item?.phone_code}
                          </option>
                        ))}
                      </select>
                      <input
                        name="mobileNo"
                        value={formData.mobileNo}
                        onChange={handleInputChange}
                        placeholder="Mobile number"
                        className="inpustxocntbusuitxtpp"
                        style={{
                          width: "70%"
                        }}
                      />
                    </div>
                    {errors.mobileNo && (
                      <span className="error">{errors.mobileNo}</span>
                    )}
                  </div>

                  {
                    formData.profileTypeID === "65ddc3d1d569c29c97f6082c" && (
                      <>
                        <div className="contatcindofdiinpur">
                          <p className="contatcindofdiinpurtxtp">
                            Company name <span> *</span>
                          </p>
                          <input
                            type="text"
                            name="companyName"
                            value={formData.companyName}
                            onChange={handleInputChange}
                            placeholder="Company name"
                            className="neooTextbox"
                          />
                          {errors.companyName && (
                            <span className="error">{errors.companyName}</span>
                          )}
                        </div>
                        <div className="contatcindofdiinpur">
                          <p className="contatcindofdiinpurtxtp">
                            Type of business <span> *</span>
                          </p>
                          <select className="neooSelect"
                            name="companyTypeID"
                            value={formData.companyTypeID}
                            onChange={handleInputChange}
                          >
                            <option value="">Choose...</option>
                            {
                              company?.map((item) => {
                                return (
                                  <><option value={item._id}>{item.type}</option></>
                                )
                              })
                            }
                          </select>

                          {errors.companyTypeID && (
                            <span className="error">{errors.companyTypeID}</span>
                          )}

                        </div>
                      </>
                    )
                  }



                  <div className="contatcindofdiinpur">
                    <p className="contatcindofdiinpurtxtp">
                      Email address <span> *</span>
                    </p>
                    <input
                      type="text"
                      name="emailId"
                      value={formData.emailId}
                      // onChange={handleInputChange}
                      placeholder="info@companyname.com"
                      className="_inpustxocntbusuitxtpp neooTextbox"
                      readOnly={true}
                    />
                    {errors.emailId && (
                      <span className="error">{errors.emailId}</span>
                    )}
                  </div>
                  <div className="contatcindofdiinpur">
                    <p className="contatcindofdiinpurtxtp">
                      Website <span> </span>
                    </p>
                    <input
                      type="text"
                      name="websiteLink"
                      value={formData.websiteLink}
                      onChange={handleInputChange}
                      placeholder="www.webname.com"
                      className="neooTextbox"
                    />
                  </div>

                  {/* <div className="contatcindofdiinpur">
                    <p className="contatcindofdiinpurtxtp">
                      Location <span> </span>
                    </p>
                    <input
                      type="text"
                      name="location"
                      value={formData.location}
                      onChange={handleInputChange}
                      placeholder="Palm Jumeirah"
                      className="inpustxocntbusuitxtpp"
                    />
                  </div>
                  <div className="contatcindofdiinpur">
                    <p className="contatcindofdiinpurtxtp">
                      Address <span> *</span>
                    </p>
                    <input
                      type="text"
                      name="address"
                      value={formData.address}
                      onChange={handleInputChange}
                      placeholder="Jumeirah tower #123, D block"
                      className="inpustxocntbusuitxtpp"
                    />
                    {errors.address && (
                      <span className="error">{errors.address}</span>
                    )}
                  </div> */}

                  <div className="contatcindofdiinpur">
                    <p className="contatcindofdiinpurtxtp">
                      Country <span> *</span>
                    </p>
                    <select className="neooSelect"
                      name="country"
                      value={formData.country}
                      onChange={handleInputChange}
                    >
                      <option value="" disabled>Choose...</option>
                      {
                        country
                          // .filter(item => item._id === "65f95f070d6753c3bdacccd9")
                          .map((item, key) => {
                            return (
                              <><option value={item?._id}>{item?.name}</option></>
                            )
                          })
                      }
                      {/* <option value="United Arab Emirate">United Arab Emirate</option> */}
                    </select>
                  </div>

                  <div className="contatcindofdiinpur">
                    <p className="contatcindofdiinpurtxtp">
                      State <span> *</span>
                    </p>
                    <select className="neooSelect"
                      name="emirate"
                      value={formData.emirate}
                      onChange={handleInputChange}
                    >
                      <option value="">Choose...</option>
                      {
                        countryState?.map((item) => {
                          return (
                            <><option value={item.name}>{item.name}</option></>
                          )
                        })
                      }
                    </select>
                    {errors.emirate && (
                      <span className="error">{errors.emirate}</span>
                    )}
                  </div>


                  {/* <div className="contatcindofdiinpurnewalasda">
                    <p className="contatcindofdiinpurtxtp">
                      Location map <span> </span>
                    </p>
                    <input
                      type="text"
                      placeholder="United arab emirate"
                      className="inpustxocntbusuitxtpp"
                    />
                  </div> */}
                </div>

                <div className="btnnexttdivbtndivmain">
                  <Link
                    onClick={handleSubmit}
                    className="btnnexttdivbtn"
                  >
                    Next
                  </Link>
                </div>
              </div>

            </div>
            <div className="listbusinessdivrightt"></div>
          </div>
        </div>
      </section>
    </>
  );
};

export default CardMemberRegistrationDetails;
